import type { UserRole } from './types';

import * as ActionTypes from 'src/state/action-types';

export interface IUserState {
  id: string;
  imageUrl: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  language: string;
  roles: string[];
  newsletter: boolean;
  jobNotificationPreferences: {
    h5p_import_finished: boolean;
    scorm_export_finished: boolean;
  };
  verified: boolean;
  APIKey: string;
  role: UserRole;
  folderView: 'grid' | 'list';
  identity_provider?: string;
  featurebase_token?: string;
  cello_token?: string;
}

export const initialState: IUserState = {
  id: '',
  imageUrl: '',
  username: '',
  email: '',
  firstName: '',
  lastName: '',
  language: '',
  roles: [],
  newsletter: false,
  jobNotificationPreferences: {
    h5p_import_finished: true,
    scorm_export_finished: true,
  },
  verified: false,
  APIKey: '',
  role: 'editor',
  folderView: 'grid',
  identity_provider: undefined,
  cello_token: undefined,
};

export default function userReducer(
  state: IUserState = initialState,
  action: ActionTypes.ActionTypes
): IUserState {
  switch (action.type) {
    case ActionTypes.USER_UPDATE_EMAIL_PREFERENCE_SUCCESS:
      return {
        ...state,
        newsletter: action.payload.newsletter,
      };

    case ActionTypes.USER_UPDATE_SETTINGS_REQUEST:
      if (action.payload.folderView) {
        return {
          ...state,
          folderView: action.payload.folderView,
        };
      }
      return state;

    case ActionTypes.AUTH_GETSESSION_SUCCESS:
      return {
        ...state,
        ...action.payload.user,
      };

    case ActionTypes.AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        email: state.email,
      };

    case ActionTypes.USER_UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case ActionTypes.AUTH_LOGOUT_REQUEST:
      return {
        ...initialState,
      };

    case ActionTypes.AUTH_REGISTER_REQUEST:
      return {
        ...state,
        email: action.payload.email,
        username: action.payload.username,
      };

    case ActionTypes.AUTH_LOGIN_REQUEST:
      return {
        ...state,
        email: action.payload.email,
      };

    default:
      return state;
  }
}
